import React from 'react';
import { useTranslation } from 'react-i18next';

import { TEXT_BLOCKS, TEXT_LOOKS, TEXT_QUICK_ADD } from '../../../../config';
import { useMediaStudio } from '../../../../context/MediaStudioContext';
import PanelSection from '../../../../components/panel-section/PanelSection';
import PreviewCard, { PREVIEW_CARD_BACKDROPS } from '../../../../components/preview-card/PreviewCard';
import { getPreviewStyle } from '../../utils/getPreviewStyle';

import scss from './TextTab.module.scss';

const HEADING = TEXT_QUICK_ADD[0];

function TextTab() {
  const { t } = useTranslation('mediaStudio');
  const { editor, textEditing } = useMediaStudio();
  const selectedText = textEditing.textElement && !textEditing.textElement.locked ? textEditing.textElement : null;

  const applyLook = (look) => {
    if (selectedText) {
      editor.applyTextLook(textEditing.textIds, look);
      return;
    }
    editor.addText({ preset: { ...look, sizeRatio: HEADING.sizeRatio, style: { ...HEADING.style, ...look.style } } });
  };

  const renderCard = (preset, sample, onClick, isTarget = false) => (
    <PreviewCard
      key={preset.id}
      name={t(preset.nameKey)}
      backdrop={PREVIEW_CARD_BACKDROPS.PHOTO}
      frameClassName={scss.lookFrame}
      isTarget={isTarget}
      onClick={onClick}>
      <span className={scss.lookSample} style={getPreviewStyle(preset)}>
        {sample}
      </span>
    </PreviewCard>
  );

  return (
    <div className={scss.textTab}>
      <PanelSection title={t('addTextGroup')} help={t('textPanelHint')}>
        <div className={scss.quickAdd}>
          {TEXT_QUICK_ADD.map((item) => (
            <button
              key={item.id}
              type='button'
              className={scss.quickAddButton}
              style={{ fontSize: item.previewSize, fontWeight: item.style.bold ? 700 : 400 }}
              onClick={() => editor.addText({ preset: item })}>
              {t(item.nameKey)}
            </button>
          ))}
        </div>
      </PanelSection>

      <PanelSection title={t('looksGroup')} help={selectedText ? t('looksHintSelected') : t('looksHintNew')}>
        <div className={scss.styleGrid}>
          {TEXT_LOOKS.map((look) => renderCard(look, t('lookSample'), () => applyLook(look), Boolean(selectedText)))}
        </div>
      </PanelSection>

      <PanelSection title={t('blocksGroup')} help={t('blocksHint')}>
        <div className={scss.styleGrid}>
          {TEXT_BLOCKS.map((block) =>
            renderCard(block, t(block.sampleKey), () => editor.addText({ preset: block, text: t(block.sampleKey) })),
          )}
        </div>
      </PanelSection>
    </div>
  );
}

export default TextTab;
